module.exports = __webpack_public_path__ + "img/logo-canada.c9d56dde.svg";